var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoalAdministration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9577_28849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113 1H39C18.0132 1 1 18.0132 1 39V113C1 133.987 18.0132 151 39 151H113C133.987 151 151 133.987 151 113V39C151 18.0132 133.987 1 113 1Z",
    fill: "#CurrentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 1H39C18.0132 1 1 18.0132 1 39V113C1 133.987 18.0132 151 39 151H113C133.987 151 151 133.987 151 113V39C151 18.0132 133.987 1 113 1Z",
    stroke: "url(#paint0_linear_9577_28849)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_9577_28849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.2042 55.52C79.1066 53.8023 77.2431 54.0945 75.4248 54.0945C76.7679 54.4315 78.0385 54.9003 79.2042 55.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.7681 51.2152C52.7095 51.2152 49.4605 59.6314 55.1032 63.8643C57.0268 59.0259 60.8561 55.5518 65.8761 54.1805C64.5029 52.3921 62.2842 51.2152 59.7681 51.2152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1863 62.5485C45.474 63.418 45.8467 64.2522 46.2895 65.0425L43.9708 67.2279C43.3481 67.8144 43.3481 68.7665 43.9708 69.3543L48.0578 73.2054C48.3554 73.4858 48.7633 73.6436 49.1883 73.6436C49.6086 73.6436 50.0137 73.4858 50.3166 73.2054L52.6326 71.02C52.9802 71.1933 53.3655 71.2995 53.7254 71.449C53.7254 71.4241 53.7228 71.3983 53.7228 71.3734C53.7228 69.5874 53.9406 67.9027 54.3283 66.3207C51.5319 64.6254 49.666 61.6826 49.666 58.3227C49.666 53.0743 54.1981 48.8038 59.7684 48.8038C63.5401 48.8038 66.7967 50.7818 68.535 53.6717C70.3909 53.4549 72.1343 53.4549 74.2328 53.8284C73.9628 53.0592 73.6453 52.3063 73.2474 51.6007L75.5661 49.4142C75.8685 49.1326 76.0361 48.7497 76.0361 48.3515C76.0361 47.9533 75.8685 47.5705 75.5661 47.2889L71.4813 43.4401C71.1689 43.1456 70.7611 42.9995 70.3534 42.9995C69.9456 42.9995 69.5379 43.1456 69.2277 43.4401L66.9017 45.6266C66.0614 45.2072 65.1785 44.8561 64.2531 44.5911V41.502C64.2531 40.6728 63.5427 40 62.6598 40H56.8795C56.0016 40 55.2836 40.6728 55.2836 41.502V44.591C54.3607 44.856 53.4776 45.2071 52.6347 45.6264L50.3166 43.4424C50.0037 43.1479 49.5961 43.0018 49.1883 43.0018C48.7806 43.0018 48.3706 43.1479 48.0603 43.4412L43.9708 47.2899C43.6732 47.5728 43.5056 47.9543 43.5056 48.3538C43.5056 48.7531 43.6732 49.1349 43.9708 49.4165L46.2895 51.6017C45.8466 52.3934 45.474 53.2264 45.1915 54.0958H41.9148C41.0318 54.0958 40.3188 54.7695 40.3188 55.6001V61.0452C40.3188 61.8733 41.0318 62.5485 41.9148 62.5485H45.1863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.258 91.6845C97.8144 90.3638 99.5696 87.8358 99.5696 84.9021C99.5696 80.6209 95.8709 77.1388 91.3261 77.1388C89.7278 77.1388 88.2468 77.5888 86.9814 78.3333C86.2235 81.1748 85.0304 83.8927 83.4697 86.2535C87.8941 87.037 91.9537 88.9349 95.258 91.6845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.316 81.9656C112.316 81.069 111.542 80.3432 110.595 80.3432H107.058C106.753 79.4042 106.348 78.5042 105.868 77.6501L108.371 75.2918C108.696 74.9878 108.876 74.5755 108.876 74.1455C108.876 73.7154 108.696 73.303 108.371 72.9981L103.964 68.8453C103.629 68.5282 103.186 68.3691 102.746 68.3691C102.306 68.3691 101.865 68.5282 101.53 68.8453L99.0217 71.2048C98.1163 70.7524 97.163 70.3733 96.1624 70.0868V66.7553C96.1624 65.86 95.3946 65.1342 94.444 65.1342H88.2089C87.7911 65.1342 87.4234 65.292 87.1235 65.5253C87.6486 67.33 87.9362 69.287 87.9362 71.3745C87.9362 72.6998 87.8264 74.0454 87.6212 75.3834C88.7817 74.9805 90.0172 74.7274 91.3255 74.7274C97.2832 74.7274 102.131 79.2926 102.131 84.9034C102.131 88.4896 100.143 91.6327 97.1581 93.446C99.3296 95.6885 101.055 98.35 102.179 101.332C102.363 101.392 102.556 101.436 102.748 101.436C103.189 101.436 103.629 101.278 103.966 100.96L108.376 96.8078C108.699 96.5034 108.876 96.0917 108.876 95.6617C108.876 95.2316 108.699 94.8193 108.376 94.5142L105.868 92.1545C106.348 91.3016 106.753 90.4013 107.059 89.4614H110.595C111.05 89.4614 111.492 89.2918 111.813 88.9853C112.136 88.6825 112.319 88.2692 112.319 87.8391L112.316 81.9656Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6674 102.797C95.9929 95.3856 88.9275 90.2878 80.7709 89.594C78.0396 92.3186 74.6579 94.0471 70.8283 94.0471C67.0016 94.0471 63.6174 92.3188 60.8886 89.594C52.7272 90.2878 45.6612 95.3856 42.9872 102.798L41.5092 106.896C41.0864 108.076 41.2888 109.375 42.0594 110.387C42.8297 111.399 44.0704 112 45.391 112H96.2632C97.5862 112 98.8273 111.399 99.5979 110.387C100.366 109.375 100.571 108.076 100.145 106.896L98.6674 102.797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5649 71.373C57.5649 80.5657 63.5055 90.4297 70.8288 90.4297C78.1551 90.4297 84.0953 80.5657 84.0953 71.373C84.0954 52.3176 57.5649 52.2798 57.5649 71.373Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_9577_28849",
    x: 40.3188,
    y: 40,
    width: 72,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9577_28849"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9577_28849",
    x1: 76,
    y1: 1,
    x2: 76,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9577_28849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 152,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalAdministration);
export default __webpack_public_path__ + "static/media/Goal-Administration.488c85932cb96e80a79ce7b60ca950e8.svg";
export { ForwardRef as ReactComponent };